/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

/// <reference types="@types/jquery" />

// tslint:disable: only-arrow-functions
// tslint:disable: no-redundant-jsdoc
// tslint:disable: no-var-keyword

import tinycolor from 'tinycolor2';

//randomColor()
// returns a random golden ratio color in a hex string
export const randomColor = (function() {
	const ratio = 0.618033988749895;
	var counter = 0;
	/* accepts parameters
 * h  Object = {h:x, s:y, v:z}
 * OR
 * h, s, v
*/
	function HSVtoRGB(h, s, v) {
		// tslint:disable-next-line: one-variable-per-declaration
		var r, g, b, i, f, p, q, t;
		if (arguments.length === 1) {
				s = h.s, v = h.v, h = h.h;
		}
		i = Math.floor(h * 6);
		f = h * 6 - i;
		p = v * (1 - s);
		q = v * (1 - f * s);
		t = v * (1 - (1 - f) * s);
		switch (i % 6) {
				case 0: r = v, g = t, b = p; break;
				case 1: r = q, g = v, b = p; break;
				case 2: r = p, g = v, b = t; break;
				case 3: r = p, g = q, b = v; break;
				case 4: r = t, g = p, b = v; break;
				case 5: r = v, g = p, b = q; break;
		}
		return {
				r: Math.round(r * 255),
				g: Math.round(g * 255),
				b: Math.round(b * 255)
		};
	}

	function doAThing(countRange?) {
		if (!countRange) { var hue = Math.random(); }
		else { var hue = counter += Number(countRange); }
		hue += ratio;
		hue % 1;

		// var rgb = HSVtoRGB(hue, 0.5, 0.95);
		// var hex = `rgba(${rgb.r},${rgb.g},${rgb.b},0.2)`;

		const rgb = HSVtoRGB(hue, 0.5, 0.95);
		const hex = '#' + rgb.r.toString(16) + rgb.g.toString(16) + rgb.b.toString(16);
		return hex;
	}
	return doAThing;
})();

enum FANCY_TEXT_SETTINGS {
	'MAGIC_CHRIS' = 57,
	'MAGIC_CHRIS_MINUS_10' = 47
}

/**
 * Returns the most readable text color, given a background color.
 * @param {string} backgroundColor
 * @param {number} luminosityVariance Defaults to "MAGIC_CHRIS" or 57 because Chris.
 * @returns {string}
 */
export function getMostReadableColor(backgroundColor: string, luminosityVariance: number = FANCY_TEXT_SETTINGS.MAGIC_CHRIS): string {
	const tc = tinycolor(backgroundColor);
	const isLight = tc.isLight();
	// return (isLight) ? tc.darken(luminosityVariance).toHexString() : tc.lighten(luminosityVariance).toHexString();
	return isLight ? tinycolor('#171717').toHexString() : tinycolor('#ffffff').toHexString();
}

/**
 * This takes a color input and makes it lighter. A value of 100 = white.
 * @param {string} color The color to make light
 * @param {number} amount The amount to make light (100 = white)
 */
export function lightenColor(color: string, amount: number = 30): string {
	return tinycolor(color).lighten(amount).toHexString();
}

/**
 * Returns a boolen indicating of the color's perceived brightness is light.
 * @param {string} backgroundColor The background color to test against
 * @returns {boolean}
 */
export function colorIsLight(backgroundColor: string): boolean {
	return tinycolor(backgroundColor).isLight();
}

/**
 * Returns a boolen indicating of the color's perceived brightness is dark.
 * @param {string} backgroundColor The background color to test against
 * @returns {boolean}
 */
export function colorIsDark(backgroundColor: string): boolean {
	return tinycolor(backgroundColor).isDark();
}

/**
 * Converts a hex string like "#00ff00" to it's numerical equivalent -> 0x65280. WebGL expects numbers for colors, so it
 * is used in the canvas renderer to convert the string hex into a numerical representation
 * @param {string} hexString
 */
// export function convertHexStringToNumber(hexString: string){
// 	return parseInt(hexString.substring(1), 16);
// }
export const convertHexStringToNumber = (() => {
	const jar = { };
	return function convertHexStringToNumberImplementation(hexString: string) {
		let hexNumber: number;
		if (jar[hexString]) { hexNumber = jar[hexString]; }
		else {
			hexNumber = parseInt(hexString.substring(1), 16);
			jar[hexString] = hexNumber;
		}
		return hexNumber;
	};
})();

/**
 * Instead of having a map of all named colors to hex string, create a canvas element and set the fillStyle and return it.
 * According to the spec, the fillStyle must be parsed when it is returned. This will give us a reliable mapping from namedColor to hex code
 * See: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-fillstyle
 */
const ctx: CanvasRenderingContext2D = document.createElement('canvas').getContext('2d');
export function colorToHex(color: string): string {
	ctx.fillStyle = color;
	return ctx.fillStyle;
}

export function rgbaToHexString(rgba: string): string {
	return tinycolor(rgba).toHexString();
}

export function rgbaToNumber(rgba: string): number {
	return convertHexStringToNumber(rgbaToHexString(rgba));
}
